import * as React from "react";
import AppIcon from "../components/AppIcon";
import { useNavigate } from "react-router-dom";
import { useUser } from "../utils/AccountStore";

const About = () => {
    const navigate = useNavigate();
    const { user } = useUser();

    return (
        <div
            className="min-h-screen bg-cover bg-center bg-no-repeat bg-fixed"
            style={{
                backgroundImage: "url(/images/collectivebg-2.jpg)",
            }}
        >
            <div className="min-h-screen backdrop-blur-sm" style={{ backgroundColor: "rgba(241, 245, 248, 0.9)" }}>
                {/* Header Section */}
                <div className="pt-8 pb-6">
                    <div className="max-w-6xl mx-auto px-8">
                        <div className="flex items-center justify-between mb-6">
                            <button
                                onClick={() => navigate("/home")}
                                className="flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
                                style={{ backgroundColor: "rgba(121, 153, 186, 0.9)" }}
                            >
                                <span className="text-white text-xl"><AppIcon kind="home" /></span>
                            </button>
                            <div className="text-center w-full">
                                <h1 className="text-2xl font-bold mb-2" style={{ color: "#013A51" }}>
                                    About The Collective
                                </h1>
                                <div className="w-24 h-1 mx-auto rounded-full" style={{ backgroundColor: "#DB1C7D" }}></div>
                            </div>
                            <div className="w-24"></div> {/* Spacer for centering */}
                        </div>
                    </div>
                </div>

                {/* Content Section */}
                <div className="px-8 pb-8">
                    <div className="max-w-6xl mx-auto space-y-8">
                        {/* Hero Section */}
                        <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg text-center" style={{ borderLeft: `4px solid #DB1C7D` }}>
                            <div className="mb-6">
                                <span className="text-6xl"><AppIcon kind="store" /></span>
                            </div>
                            <h2 className="text-2xl font-bold mb-4" style={{ color: "#013A51" }}>
                                Welcome to The Collective Artisan Markets
                            </h2>
                        </div>

                        {/* Mission & Vision Grid */}

                        <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg" style={{ borderLeft: `4px solid #7999BA` }}>
                            <div className="text-center mb-6">
                                <span className="text-4xl"><AppIcon kind="bullseye" /></span>
                                <h3 className="text-2xl font-bold mt-4" style={{ color: "#013A51" }}>
                                    Our Story
                                </h3>
                            </div>
                            <p className="text-md leading-relaxed mb-2" style={{ color: "#8B6F4C" }}>
                                The Creative You Market brings together a unique collective of hand-picked artisans who embrace creativity with purpose. The brainchild and founder together with
                                amazing friends through the years established the Creative You Market as more than an annual market – it’s a platform that was created because of a dream to do
                                something that is not only beautiful but also worthwhile.
                            </p>
                            <p className="text-md leading-relaxed mb-2" style={{ color: "#8B6F4C" }}>
                                Since its inception in 2009, it has grown into one of the most anticipated events on Cape Town’s cultural calendar, providing small businesses with the opportunity to
                                nurture their talents and ideas into realities. Every event is carefully planned in collaboration with a list of carefully curated exhibitors and presented according to
                                the markets unique style and flair.
                            </p>
                            <p className="text-md leading-relaxed mb-2" style={{ color: "#8B6F4C" }}>
                                The Creative You Market believes in inspiring business owners to dream and create, pouring their inner beauty into creations that speak of style, passion, quality and
                                the extraordinary. It prides itself on providing a service of guidance, hands-on mentoring and challenging exhibitors to push their creativity and believe in their
                                dreams. Exhibitors don’t just hire a space, they go on a journey with us.
                            </p>
                            <p className="text-md leading-relaxed mb-2" style={{ color: "#8B6F4C" }}>
                                Visitors gets spoiled with over 150 exquisite decor and fashion displays, as well as mouth watering food truck cuisine, exquisite deli items, great coffee, fine wine,
                                craft beer and delightful children’s entertainment. The Creative You Market goes from strength to strength and everyone agrees: it’s a market with a distinct
                                difference. One with heart and soul – a collective of like-minded creators who are passionate about their craft.
                            </p>
                        </div>

                        {/* What Makes Us Special */}
                        <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg" style={{ borderLeft: `4px solid #708372` }}>
                            <h3 className="text-2xl font-bold mb-6 text-center" style={{ color: "#013A51" }}>
                                <AppIcon kind="sparkle" /> What Makes Us Special
                            </h3>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                                <div className="text-center">
                                    <div className="mb-4">
                                        <span className="text-3xl"><AppIcon kind="palette" /></span>
                                    </div>
                                    <h4 className="text-xl font-bold mb-3" style={{ color: "#013A51" }}>
                                        Handcrafted Excellence
                                    </h4>
                                    <p className="text-base" style={{ color: "#8B6F4C" }}>
                                        Every item in our market is carefully crafted by skilled artisans who pour their passion into their work.
                                    </p>
                                </div>

                                <div className="text-center">
                                    <div className="mb-4">
                                        <span className="text-3xl"><AppIcon kind="handshake" /></span>
                                    </div>
                                    <h4 className="text-xl font-bold mb-3" style={{ color: "#013A51" }}>
                                        Community First
                                    </h4>
                                    <p className="text-base" style={{ color: "#8B6F4C" }}>
                                        We prioritize local makers and small businesses, creating opportunities for our community to thrive.
                                    </p>
                                </div>

                                <div className="text-center">
                                    <div className="mb-4">
                                        <span className="text-3xl"><AppIcon kind="gem" /></span>
                                    </div>
                                    <h4 className="text-xl font-bold mb-3" style={{ color: "#013A51" }}>
                                        Unique Discoveries
                                    </h4>
                                    <p className="text-base" style={{ color: "#8B6F4C" }}>
                                        Find treasures you won't see anywhere else - from handmade jewelry to artisanal foods and crafts.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Our Journey */}
                        <div className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg" style={{ borderLeft: `4px solid #8B6F4C` }}>
                            <h3 className="text-2xl font-bold mb-6 text-center" style={{ color: "#013A51" }}>
                                <AppIcon kind="history" /> Our Journey
                            </h3>
                            <div>
                                {/* 2009 */}
                                <div className="relative pl-8 border-l-4 pb-8" style={{ borderColor: "#DB1C7D" }}>
                                    <div className="absolute -left-3 top-0 w-6 h-6 rounded-full" style={{ backgroundColor: "#DB1C7D" }}></div>
                                    <div className="mb-2">
                                        <span className="inline-block px-3 py-1 rounded-full text-sm font-bold text-white" style={{ backgroundColor: "#DB1C7D" }}>
                                            2009
                                        </span>
                                    </div>
                                    <p className="text-lg leading-relaxed" style={{ color: "#8B6F4C" }}>
                                        Founded in 2009, the Creative You Market has evolved from a dream into a renowned platform for hand-picked artisans. The brainchild and founder, together with
                                        amazing friends through the years, established the Creative You Market as more than an annual market but a platform that was created with the dream to do
                                        something that is not only beautiful but also worthwhile.
                                    </p>
                                </div>

                                {/* 2010-2015 */}
                                <div className="relative pl-8 border-l-4 pb-8" style={{ borderColor: "#7999BA" }}>
                                    <div className="absolute -left-3 top-0 w-6 h-6 rounded-full" style={{ backgroundColor: "#7999BA" }}></div>
                                    <div className="mb-2">
                                        <span className="inline-block px-3 py-1 rounded-full text-sm font-bold text-white" style={{ backgroundColor: "#7999BA" }}>
                                            2010 - 2015
                                        </span>
                                    </div>
                                    <p className="text-lg leading-relaxed" style={{ color: "#8B6F4C" }}>
                                        From 2010 to 2015, the Creative You Market became a sought-after destination for visitors from all over. They indulged in the market's retro French ambience,
                                        strolling through the space and immersing themselves in the creativity on display.
                                    </p>
                                </div>

                                {/* 2016-2019 */}
                                <div className="relative pl-8 border-l-4 pb-8" style={{ borderColor: "#708372" }}>
                                    <div className="absolute -left-3 top-0 w-6 h-6 rounded-full" style={{ backgroundColor: "#708372" }}></div>
                                    <div className="mb-2">
                                        <span className="inline-block px-3 py-1 rounded-full text-sm font-bold text-white" style={{ backgroundColor: "#708372" }}>
                                            2016 - 2019
                                        </span>
                                    </div>
                                    <p className="text-lg leading-relaxed" style={{ color: "#8B6F4C" }}>
                                        In 2016, the market took a leap of faith by hosting its first event at the renowned Meerendal Wine Estate, combining beauty, good food, and wine. The following
                                        years saw the market moving to Stone Shed on Vrymansfontein farm, gaining a new family and continuously improving with the help of everyone involved. Exhibitors
                                        and the market team worked together, upholding the standard and quality of this beloved calendar event.
                                    </p>
                                </div>

                                {/* 2020-2022 */}
                                <div className="relative pl-8 border-l-4 pb-8" style={{ borderColor: "#DDB649" }}>
                                    <div className="absolute -left-3 top-0 w-6 h-6 rounded-full" style={{ backgroundColor: "#DDB649" }}></div>
                                    <div className="mb-2">
                                        <span className="inline-block px-3 py-1 rounded-full text-sm font-bold" style={{ backgroundColor: "#DDB649", color: "#013A51" }}>
                                            2020 - 2022
                                        </span>
                                    </div>
                                    <p className="text-lg leading-relaxed" style={{ color: "#8B6F4C" }}>
                                        The years 2020 and 2021 posed challenges due to the COVID-19 pandemic. The market had to adapt and hosted smaller pop-ups called SPOIL under the names of Stone
                                        Shed and Picardi Place. These events provided an opportunity for creativity to thrive in difficult times, thanks to the gracious hosts. In 2022, the Creative
                                        You Market underwent a significant change with a new owner and a fresh vision.
                                    </p>
                                </div>

                                {/* 2023 */}
                                <div className="relative pl-8 border-l-4 pb-8" style={{ borderColor: "#013A51" }}>
                                    <div className="absolute -left-3 top-0 w-6 h-6 rounded-full" style={{ backgroundColor: "#013A51" }}></div>
                                    <div className="mb-2">
                                        <span className="inline-block px-3 py-1 rounded-full text-sm font-bold text-white" style={{ backgroundColor: "#013A51" }}>
                                            2023
                                        </span>
                                    </div>
                                    <p className="text-lg leading-relaxed" style={{ color: "#8B6F4C" }}>
                                        In 2023, we proudly announced the new Creative You Artisan Market, offering a vibrant celebration of creativity and craftsmanship at the beautiful Canto Wines.
                                    </p>
                                </div>

                                {/* 2024 */}
                                <div className="relative pl-8 border-l-4 pb-8" style={{ borderColor: "#8B6F4C" }}>
                                    <div className="absolute -left-3 top-0 w-6 h-6 rounded-full" style={{ backgroundColor: "#8B6F4C" }}></div>
                                    <div className="mb-2">
                                        <span className="inline-block px-3 py-1 rounded-full text-sm font-bold text-white" style={{ backgroundColor: "#8B6F4C" }}>
                                            2024
                                        </span>
                                    </div>
                                    <p className="text-lg leading-relaxed" style={{ color: "#8B6F4C" }}>
                                        In 2024, we partnered with Durbanville High School bringing family and friends together to celebrate community and creativity in the heart of Durbanville. This
                                        was a beautiful and significant moment for our team who holds the community of Durbanville close to their hearts.
                                    </p>
                                </div>

                                {/* 2025 */}
                                <div className="relative pl-8 border-l-4 pb-8" style={{ borderColor: "#DB1C7D" }}>
                                    <div className="absolute -left-3 top-0 w-6 h-6 rounded-full" style={{ backgroundColor: "#DB1C7D" }}></div>
                                    <div className="mb-2">
                                        <span className="inline-block px-3 py-1 rounded-full text-sm font-bold text-white" style={{ backgroundColor: "#DB1C7D" }}>
                                            2025
                                        </span>
                                    </div>
                                    <p className="text-lg leading-relaxed" style={{ color: "#8B6F4C" }}>
                                        In 2025 our amazing team of visionaries and creatives brought us an even better and bigger CY Creative You Market, hosted by Durbanville High School. The market
                                        coincided with Durbanville's 200 Year Celebration, with a focus on heritage and community.
                                    </p>
                                </div>

                                {/* 2026 */}
                                <div className="relative pl-8 border-l-4 pb-8" style={{ borderColor: "#F1F5F8" }}>
                                    <div className="absolute -left-3 top-0 w-6 h-6 rounded-full animate-pulse" style={{ backgroundColor: "#DB1C7D" }}></div>
                                    <div className="mb-2">
                                        <span className="inline-block px-3 py-1 rounded-full text-sm font-bold text-white animate-pulse" style={{ backgroundColor: "#DB1C7D" }}>
                                            2026
                                        </span>
                                    </div>
                                    <p className="text-lg leading-relaxed font-semibold" style={{ color: "#013A51" }}>
                                        It is our honour to host this year's event at Durbanville High School once again from 26 September - 3 October.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Call to Action */}
                        <div className="bg-gradient-to-r from-pink-100 to-blue-100 bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg text-center" style={{ borderLeft: `4px solid #DB1C7D` }}>
                            <h3 className="text-2xl font-bold mb-4" style={{ color: "#013A51" }}>
                                Ready to Explore?
                            </h3>
                            <p className="text-lg mb-6" style={{ color: "#708372" }}>
                                Discover amazing vendors, find unique treasures, and experience the magic of artisan craftsmanship.
                            </p>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <button
                                    onClick={() => navigate("/exhibitors")}
                                    className="px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg backdrop-blur-sm text-white"
                                    style={{ backgroundColor: "rgba(112, 131, 114, 0.9)" }}
                                >
                                    <AppIcon kind="store" /> Browse Vendors
                                </button>

                                <button
                                    onClick={() => navigate("/floorPlans")}
                                    className="px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg backdrop-blur-sm text-white"
                                    style={{ backgroundColor: "rgba(1, 58, 81, 0.9)" }}
                                >
                                    <AppIcon kind="map" /> View Map
                                </button>

                                <button
                                    onClick={() => navigate("/scanner")}
                                    className="px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg backdrop-blur-sm text-white"
                                    style={{ backgroundColor: "rgba(221, 182, 73, 0.9)" }}
                                >
                                    <AppIcon kind="qr" /> QR Scanner
                                </button>
                            </div>
                        </div>

                        {/* Contact Information */}
                        <div
                            className="bg-white bg-opacity-60 backdrop-blur-sm rounded-2xl p-8 shadow-lg transition-all duration-300  hover:-translate-y-1 hover:shadow-lg backdrop-blur-sm text-white"
                            style={{ borderLeft: `4px solid #013A51` }}
                            onClick={() => navigate("/contact")}
                        >
                            <h3 className="text-2xl font-bold text-center" style={{ color: "#013A51" }}>
                                <AppIcon kind="phone" /> Get In Touch
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
